import errorTrackerV2 from "./Utils/ErrorTrackerV2";
// import { shouldBypassValidation } from "../../Utils/validationPolicy";
import { auth } from "../../../../../backend/firebaseConfig";

// ---- VALIDATION (Section 11) - same pattern as Sections 1/2/3/9/10 ----
export const validateSection11 = ({
  formData,
  setErrors,
  onValidationStatusChange,
}) => {
  // bypass: no errors, mark valid
  // if (shouldBypassValidation(auth.currentUser?.uid)) {
  //   setErrors({});
  //   errorTrackerV2.setSectionErrors("section11", {});
  //   onValidationStatusChange?.(true);
  //   return true;
  // }

  const f = formData;
  const newErrors = {};

  // If data is null, all required fields are missing
  if (formData === null || formData === undefined) {
    newErrors["dataNotFound"] =
      "No data found for this section. Please open and save it first.";
    errorTrackerV2.setSectionErrors("section11", newErrors);
    onValidationStatusChange?.(false);
    return false;
  }

  const req = (cond, key, msg = "This field is required.") => {
    if (cond) newErrors[key] = msg;
  };

  // Declaration section (required)
  req(!f.fullname?.trim(), "fullname");
  req(!f.candidateSignature, "candidateSignature");
  req(!f.date, "date");

  // Reference consent block (optional?):
  // If you WANT these required, uncomment these three lines.
  // req(!f.printName?.trim(), "printName");
  // req(!f.printNameSignature, "printNameSignature");
  // req(!f.printNameDate, "printNameDate");

  // setErrors(newErrors);
  errorTrackerV2.setSectionErrors("section11", newErrors);

  const ok = Object.keys(newErrors).length === 0;
  onValidationStatusChange?.(ok);

  return ok;
};
